import request from "@/utils/request";

export function getData(params) {
  return request({
    url: "/SystemConfiguration/GetParameterGroup",
    method: "get",
    params
  });
}
export function saveData(data) {
  return request({
    url: "/SystemConfiguration/Save",
    method: "post",
    data
  });
}
export function getPickUp(params) {
  return request({
    url: "/SystemConfiguration/SearchPickUpServiceGroup",
    method: "get",
    params
  });
}
export function setPickUp(data) {
  return request({
    url: "/SystemConfiguration/AddPickUpService",
    method: "post",
    data
  });
}
export function delPickUp(data) {
  return request({
    url: "/SystemConfiguration/DeletePickUpService",
    method: "post",
    data
  });
}
export function pickUpSortUp(data) {
  return request({
    url: "/SystemConfiguration/PickUpServiceUpSort",
    method: "post",
    data
  });
}
export function pickUpSortDown(data) {
  return request({
    url: "/SystemConfiguration/PickUpServiceDownSort",
    method: "post",
    data
  });
}
export function getArrivalGroup(params) {
  return request({
    url: "/SystemConfiguration/GetArrivalGroup",
    method: "get",
    params
  });
}
